import { z } from 'zod';

import {
  AI_TOOL_SELECT_USAGE_NOTE,
  aiToolRowLimitSchema,
  createAiToolFieldMaskSchema,
  createFindManyAiToolInputSchema,
} from '@erikdakoda/ai-tool/findManyAiToolInput';
import {
  AI_MODEL_AI_TOOL_FILTER_FIELDS,
  AI_MODEL_AI_TOOL_SCALAR_FIELDS,
  AI_MODEL_AI_TOOL_SEARCH_SCALAR_FIELDS,
  AI_MODEL_AI_TOOL_SORTABLE_FIELDS,
  aiModelFilterFieldMappings,
} from '../shared/aiModelAiToolQueryInput';

export const findAiModelsInputSchema = createFindManyAiToolInputSchema({
  filterableFields: AI_MODEL_AI_TOOL_FILTER_FIELDS,
  filterFieldMappings: aiModelFilterFieldMappings,
  sortableFields: AI_MODEL_AI_TOOL_SORTABLE_FIELDS,
  selectableScalars: AI_MODEL_AI_TOOL_SEARCH_SCALAR_FIELDS,
});

export const readAiModelInputSchema = z.object({
  aiModelId: z.string().describe('AI model catalog row id to load.'),
  select: createAiToolFieldMaskSchema(AI_MODEL_AI_TOOL_SCALAR_FIELDS),
});

export const aiModelTextSearchBaseInputSchema = z.object({
  query: z
    .string()
    .min(1)
    .max(500)
    .describe(
      'Substring to match (case-insensitive) against modelName, label, description, and integration.',
    ),
  limit: aiToolRowLimitSchema,
  onlyEnabled: z
    .boolean()
    .optional()
    .describe(
      'When true, restrict to enabled models only (`disabled` is false). Defaults to including disabled models.',
    ),
});

export const searchAiModelsInputSchema = aiModelTextSearchBaseInputSchema.extend({
  select: createAiToolFieldMaskSchema(AI_MODEL_AI_TOOL_SEARCH_SCALAR_FIELDS),
});

export { AI_TOOL_SELECT_USAGE_NOTE };

export type FindAiModelsInput = z.infer<typeof findAiModelsInputSchema>;
export type ReadAiModelInput = z.infer<typeof readAiModelInputSchema>;
export type SearchAiModelsInput = z.infer<typeof searchAiModelsInputSchema>;
